import { CustomFieldDefinitionModelInput, ValueModelInput } from 'src/graphql/types';
import { filterNotEmpty } from 'src/utils/data/listHelpers';

export const tagsToValues = (tags: string[] | undefined): { value: string; label: string }[] =>
  tags?.map((tag) => ({ value: tag, label: tag })) ?? [];

export const valuesToOptions = (
  values: InputMaybe<InputMaybe<ValueModelInput>[]> | undefined
): { value: string; label: string }[] =>
  filterNotEmpty(values?.map((v) => (v?.value && v.label ? { value: v.value, label: v.label } : undefined))) ?? [];

export const objectToOptions = (
  customObjectDefinitions:
    | ({
        name?: string | null | undefined;
        uid?: string | null | undefined;
      } | null)[]
    | null
    | undefined
): { label: string; value: string }[] =>
  filterNotEmpty(
    customObjectDefinitions?.map((object) =>
      object?.name && object.uid
        ? {
            value: object.uid,
            label: object.name
          }
        : undefined
    )
  ) ?? [];

export function isCodeValid(code?: string | null) {
  if (!code || code === '') return true;
  return /^[a-zA-Z0-9 #._-]+$/.test(code);
}

export const checkIfFormIsValid = (
  customFieldDefinition: CustomFieldDefinitionModelInput | undefined,
  customFieldCodeChecker: boolean
): boolean => {
  const hasRequiredFields =
    !!customFieldDefinition?.name && !!customFieldDefinition.parentEntityType && !!customFieldDefinition.code;

  if (customFieldCodeChecker && isCodeValid(customFieldDefinition?.code) === false) {
    return false;
  }

  if (customFieldDefinition?.dataType === 'OBJECT') {
    return hasRequiredFields && !!customFieldDefinition.customObjectDefinition;
  }

  return hasRequiredFields;
};
